/* eslint-disable import/prefer-default-export */
import React from 'react'

import wrapWithProvider from './wrap-with-provider'
import Tracking from '~/components/common/Tracking'
import 'firebase/firestore'
import 'firebase/analytics'

export const wrapRootElement = wrapWithProvider

export const wrapPageElement = ({ element, location, props }) => (
  <React.Fragment>
    <Tracking location={location} {...props} />
    {element}
  </React.Fragment>
)

export const shouldUpdateScroll = ({ routerProps }) => {
  const { preventScroll } = routerProps.location.state || {}

  return !preventScroll
}
